module.exports = __webpack_public_path__ + "static/img/医保结算前置检查与拒付风险预警.8847ec33.png";